export const WELLSITE_NDVI_LEASE = ({ idToken, timeIso }) =>
  `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3AWellsiteNdviLease&width=512&height=512&srs=EPSG:3857&format=image%2Fpng8&transparent=true&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

const makeGeoserverUrlFunction = (
  width = 512,
  height = 512,
  srs = 'EPSG:3857',
  format = 'image%2Fpng8',
  transparent = true
) => {
  const urlFunction = ({ id, idToken, timeIso }) => `https://geoserver.looknorthservices.com/geoserver/coresight2/wms?service=WMS&request=GetMap&version=1.1.1&layers=coresight2%3A${id}&width=${width}&height=${height}&srs=${srs}&format=${format}&transparent=${transparent}&TIME=${encodeURIComponent(
    timeIso
  )}&BBOX={bbox-epsg-3857}&token=${idToken}`

  return urlFunction  
}

export default makeGeoserverUrlFunction



// WEBPACK FOOTER //
// ./src/utility/makeGeoserverUrlFunction.js